import { render, staticRenderFns } from "./about-components.vue?vue&type=template&id=d12d4382&scoped=true"
import script from "./about-components.vue?vue&type=script&lang=js"
export * from "./about-components.vue?vue&type=script&lang=js"
import style0 from "./about-components.vue?vue&type=style&index=0&id=d12d4382&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12d4382",
  null
  
)

export default component.exports